import React from 'react';
import styles from './MainSingleFormContent.module.scss';

export default function (props) {
  return (
    <div className={styles.root}>
      {props.children}
    </div>
  );
}